import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTelevisionOld: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="television-old, tv, monitor, video, screen, display"><path d="M2.75 6.75H21.25V20.25H2.75V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.5857 6.42779L7.5 3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.4141 6.42779L16.4998 3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTelevisionOld;
